import {Component, OnInit} from '@angular/core';
import {GlobalService} from "../../../../global.service";
import {EventsService} from "../../../events.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-insomnia-tournaments',
  templateUrl: './insomnia-tournaments.component.html',
  styleUrls: ['./insomnia-tournaments.component.css']
})
export class InsomniaTournamentsComponent implements OnInit {
  
  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }
  
  ngOnInit() {
    this.activeRoute.params.subscribe(param => {
      this.changeRoute(param['code']);
    });
  }
  
  changeRoute(param) {
    this.eventService.loadEventTournaments = true;
    this.eventService.getEventTournaments('insomnia-egypt19', 1, param).subscribe(res => {
      this.eventService.eventTournaments.next(res);
      this.eventService.loadEventTournaments = false;
    })
  }
  
}
